import { format } from "date-fns";

import type { MembranesFlowsheetFormValues } from "@/encounters/components/EncounterLabor/flowsheet-forms/membranes/types/membranes-form";
import type { MembranesFlowsheetFormSchemaType } from "@/encounters/components/EncounterLabor/flowsheet-forms/membranes/zod-schemas/membranes-flowsheet-form";
import { localToUtcTimeString } from "@/utils/timeUtils";

/** Empty form values with null datetime. Used when hydrating from a QuestionnaireResponse. */
export function getEmptyMembranesFlowsheetFormValues(): MembranesFlowsheetFormValues {
  return {
    examDate: null,
    examTime: null,
    fluidColor: null,
    fluidColorOther: "",
    pooling: null,
    nitrazine: null,
    fernResults: null,
    notes: "",
    signatureInitials: [],
  };
}

/** Defaults for a new quick-add form, with the current local date and time filled in. */
export function getDefaultMembranesFlowsheetFormValues(): MembranesFlowsheetFormValues {
  const now = new Date();
  const localTime = format(now, "HH:mm:ss");
  return {
    ...getEmptyMembranesFlowsheetFormValues(),
    examDate: now,
    examTime: localToUtcTimeString(localTime),
  };
}

export function normalizeMembranesFlowsheetFormValues(
  parsed: MembranesFlowsheetFormSchemaType,
): MembranesFlowsheetFormValues {
  // Keep explicit null date/time from the form. Current date/time only comes from
  // getDefaultMembranesFlowsheetFormValues for new quick-add entries.
  const empty = getEmptyMembranesFlowsheetFormValues();
  return {
    examDate: parsed.examDate !== undefined ? parsed.examDate : empty.examDate,
    examTime: parsed.examTime !== undefined ? parsed.examTime : empty.examTime,
    fluidColor: parsed.fluidColor ?? empty.fluidColor,
    fluidColorOther: parsed.fluidColorOther ?? empty.fluidColorOther,
    pooling: parsed.pooling ?? empty.pooling,
    nitrazine: parsed.nitrazine ?? empty.nitrazine,
    fernResults: parsed.fernResults ?? empty.fernResults,
    notes: parsed.notes ?? empty.notes,
    signatureInitials: parsed.signatureInitials ?? empty.signatureInitials,
  };
}
